import { Action } from '../../common/actions/core/action';
import ActionDispatcherService from '../../common/actions/core/action-dispatcher.service';
import { ActionHandler } from '../../common/actions/core/action-handler';
import { PromocodeAction } from './promocode-redirect.action';

/* @ngInject */
export default class PromocodeRedirectController implements ActionHandler {
  private offerId: string;
  private name: string;
  private promocode: string;
  private dialogElement;

  constructor(
    private $element,
    private actionDispatcher: ActionDispatcherService
  ) {
    this.actionDispatcher.register(this);
  }

  public $postLink() {
    this.dialogElement = this.$element
      .find('#promocode-redirect')
      .remodal();
  }

  public $onDestroy() {
    this.actionDispatcher.unregister(this);
    this.dialogElement.destroy();
  }

  public handle(action: Action) {
    if (action instanceof PromocodeAction) {
      this.offerId = action.offerId;
      this.name = action.name;
      this.promocode = action.promocode;
      
      this.openDialog();
    }
  }

  public onClick() {
    this.dialogElement.close();
    window.location.href = window.location.href.split('/buy/')[0] + "/buy/" + this.offerId + (this.promocode ? '?promocode=' + this.promocode : '');
  }

  private openDialog() {
    this.dialogElement.open();
  }

  private close() {
    this.dialogElement.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/promocode-redirect/promocode-redirect.controller.ts